import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/600.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/600.css";
import { installPerfReporter } from "./lib/perf-reporter";

// Web-vitals telemetry → perf_events. No-op for anonymous visitors.
installPerfReporter();

// Restore accessibility + theme preferences before first paint
(() => {
  try {
    const flags = ['reduceMotion', 'compactMode', 'highContrast'] as const;
    flags.forEach((k) => {
      if (localStorage.getItem(`a11y:${k}`) === '1') {
        document.documentElement.classList.add(`a11y-${k}`);
      }
    });
    const scale = localStorage.getItem('a11y:textScale');
    if (scale) document.documentElement.style.fontSize = `${Number(scale)}%`;

    // Theme — default dark; respect saved pref; fall back to system only when unset.
    const saved = localStorage.getItem('ftos-theme');
    let theme: 'light' | 'dark' = 'dark';
    if (saved === 'light' || saved === 'dark') {
      theme = saved;
    } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
      theme = 'light';
    }
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(theme);
    document.documentElement.style.colorScheme = theme;
  } catch { /* localStorage unavailable */ }
})();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
